export default function Contact() {
  return (
    <section id="contact" className="relative py-20 overflow-hidden border-t border-white/10">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Pronto para Começar?
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed">
            Entre em contato agora e descubra como é fácil ter o produto dos seus sonhos! 💙
          </p>
        </div>

        <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-6 md:p-12 shadow-2xl">
          <div className="grid gap-6">
            {/* Instagram Button */}
            <a
              href="https://www.instagram.com/steel.importacoes/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 md:gap-4 w-full px-6 md:px-8 py-5 md:py-6 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-lg md:text-xl font-bold rounded-2xl hover:from-purple-700 hover:to-pink-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer group"
            >
              <i className="ri-instagram-line text-2xl md:text-3xl group-hover:scale-110 transition-transform flex-shrink-0"></i>
              <span>Acompanhe nosso dia a dia</span>
              <i className="ri-arrow-right-line text-xl md:text-2xl group-hover:translate-x-1 transition-transform flex-shrink-0"></i>
            </a>

            {/* WhatsApp Button */}
            <a
              href="https://wa.me/5569992652963"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 md:gap-4 w-full px-6 md:px-8 py-5 md:py-6 bg-gradient-to-r from-green-600 to-green-700 text-white text-lg md:text-xl font-bold rounded-2xl hover:from-green-700 hover:to-green-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer group"
            >
              <i className="ri-whatsapp-line text-2xl md:text-3xl group-hover:scale-110 transition-transform flex-shrink-0"></i>
              <span>Quero fazer um orçamento</span>
              <i className="ri-arrow-right-line text-xl md:text-2xl group-hover:translate-x-1 transition-transform flex-shrink-0"></i>
            </a>
          </div>

          <div className="mt-8 text-center">
            <p className="text-gray-300 text-base md:text-lg">
              Estamos online e prontos para te atender! 🚀
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
